/// <amd-module name="Build/Admin/Agent/Stores/SelectionStore" />
import { Store } from "VSS/Reflux/Store";

import { TaskAgent, TaskAgentPool, TaskAgentQueue } from "DistributedTask/Client/Contracts/TaskAgent";

import { AgentHubViewKeys } from "Build/Admin/Common/Constants";

export interface ISelectionState {
    selectedAgent: TaskAgent | undefined;
    selectedAgentQueue: TaskAgentQueue | undefined;
    selectedAgentPool: TaskAgentPool | undefined;
    selectedTabId: string;
}

export class SelectionStore extends Store {
    public state: ISelectionState = {
        selectedAgent: undefined,
        selectedAgentQueue: undefined,
        selectedAgentPool: undefined,
        selectedTabId: AgentHubViewKeys.Capabilities
    };

    constructor() {
        super("SelectionStoreChanged");
    }

    public updateSelectedAgent = (newAgent: TaskAgent | undefined) => {
        this.state = {
            ...this.state,
            selectedAgent: newAgent
        };
        this.emitChanged();
    }

    public updateSelectedAgentQueue = (newAgentQueue: TaskAgentQueue | undefined) => {
        this.state = {
            ...this.state,
            selectedAgentQueue: newAgentQueue
        };
        this.emitChanged();
    }

    public updateSelectedAgentPool = (newAgentPool: TaskAgentPool | undefined) => {
        this.state = {
            ...this.state,
            selectedAgentPool: newAgentPool
        };
        this.emitChanged();
    }

    public updateSelectedTab = (newTabId: string) => {
        this.state = {
            ...this.state,
            selectedTabId: newTabId
        };
        this.emitChanged();
    }
}
